import promise from 'promise'
const cookie = require('cookie');

export default instance => {
	instance.interceptors.request.use(
		function (config) {
			const accessToken = cookie.parse(document.cookie).oauth_access_token
			if (accessToken) {
				if (config.method !== 'OPTIONS') {
					// config.headers && (config.headers.authorization = 'Bearer ' + accessToken)
				}
			}
			return config
		},
		function (error) {
			return promise.reject(error)
		}
	)
}
